import { Outlet } from 'react-router-dom';
import { AppHeader } from '../App/AppHeader';
import { AppFooter } from '../App/AppFooter';

export function ProfileLayout()  {
  return (
    <>
      <div class="m-0 p-0 row sticky-top bg-white noprint">
          <div class="m-0 p-0 col-sm-12 col-md-12">
              <AppHeader/>
          </div>    
      </div> 
      <div class="m-0 p-0 row align-items-top homepageheight overflow-auto">
        <div class="m-0 p-0 col-sm-12 col-md-12">
          <Outlet/>
        </div>
      </div>
      <div class="m-0 p-0 row noprint">
          <div class="m-0 p-0 col-sm-12 col-md-12">
              <AppFooter/>
          </div>    
      </div> 
    </>
  );
}
